var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLinkDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "External Link@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tax-Information-Default-Minimized-View---Mobile-(External-Link-Version)",
    transform: "translate(-327.000000, -408.000000)",
    fill: "#A8A8A8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Templates-/-Cells-/-Tax-Forms---Mobile",
    transform: "translate(0.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "External-Link",
    transform: "translate(327.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1275925,22.2748432 C22.1266424,23.2207129 21.3648994,23.9877747 20.4250168,23.9892434 L1.7301285,24 C0.79024595,23.9992829 0.0277961044,23.2334277 0.0251814347,22.287558 L1.99206128e-06,3.43013554 C-0.00142112688,2.48377638 0.759839166,1.71573539 1.70020816,1.71432794 L12.7584368,1.71432794 C13.2287368,1.71432794 13.6097246,2.09798127 13.6097246,2.57103846 C13.6097246,3.04433431 13.2287368,3.42774899 12.7584368,3.42774899 L1.70081623,3.42774899 L1.69725334,22.2790521 L20.424369,22.2747495 L20.424369,11.1375127 C20.424369,10.6644555 20.8055939,10.2808022 21.2756568,10.2808022 C21.7457197,10.2808022 22.1269446,10.6644555 22.1269446,11.1375127 L22.1275925,22.2748432 Z M24,0.857080134 L23.9914494,0.952933803 L23.9862239,7.74358858 C23.9862239,8.16429464 23.6850443,8.51401612 23.2879246,8.58640815 L23.1349604,8.60027218 C22.6646603,8.60027218 22.2836726,8.2168575 22.2836726,7.74356165 L22.2872354,3.04505517 L12.0152319,13.3824915 C11.6826946,13.7169024 11.1437564,13.7169024 10.8112069,13.3824915 C10.4789128,13.0478359 10.4789128,12.5054647 10.8112069,12.1707969 L21.2023907,1.71342105 L16.3053576,1.71796278 C15.8352947,1.71796278 15.4540698,1.33430945 15.4540698,0.861252253 C15.4540698,0.387956404 15.8352947,0.00454172846 16.3053576,0.00454172846 L23.1484955,0 C23.6185584,0 23.9997833,0.383653331 23.9997833,0.856710524 L24,0.857080134 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkDisabled);
export default __webpack_public_path__ + "static/media/external-link-disabled.309ae91c.svg";
export { ForwardRef as ReactComponent };